import { S, formatDate } from '../regureStyles';

const CategoriesTab = ({ categories }) => {
  return (
    <div style={{ background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 10, overflow: 'hidden' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: S.bgCard }}>
            {['Data Category', 'Primary Region', 'Retention Period', 'Encryption', 'Last Audit', 'Status'].map(h => (
              <th
                key={h}
                style={{
                  padding: '12px 16px',
                  textAlign: 'left',
                  fontSize: 11,
                  fontWeight: 600,
                  color: S.textMuted,
                  textTransform: 'uppercase',
                  letterSpacing: '0.06em',
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {categories.map((row, i) => (
            <tr key={row.category} style={{ borderTop: `1px solid ${S.borderLight}`, background: i % 2 === 0 ? '#fff' : S.bgCard }}>
              <td style={{ padding: '14px 16px', fontWeight: 500, color: S.textPrimary, fontSize: 13 }}>{row.category}</td>
              <td style={{ padding: '14px 16px', fontSize: 13, color: S.textSecondary }}>{row.region}</td>
              <td style={{ padding: '14px 16px', fontSize: 13, color: S.textSecondary }}>{row.retention}</td>
              <td style={{ padding: '14px 16px', fontSize: 12 }}>
                <span style={{ padding: '3px 8px', background: `${S.success}15`, color: S.success, borderRadius: 4, fontWeight: 500 }}>{row.encryption}</span>
              </td>
              <td style={{ padding: '14px 16px', fontSize: 13, color: S.textSecondary }}>
                {row.lastAudit ? (typeof row.lastAudit === 'string' ? row.lastAudit.split('T')[0] : formatDate(row.lastAudit)) : '—'}
              </td>
              <td style={{ padding: '14px 16px' }}>
                <span
                  style={{
                    padding: '3px 10px',
                    borderRadius: 20,
                    fontSize: 12,
                    fontWeight: 500,
                    background: row.status === 'compliant' ? '#ecfdf5' : '#fffbeb',
                    color: row.status === 'compliant' ? S.success : S.warning,
                  }}
                >
                  {row.status === 'compliant' ? 'Compliant' : 'Under Review'}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CategoriesTab;
